// extracted by mini-css-extract-plugin
export default {"portrait":"portrait_portrait__RJBHt"};